<div class="translate_wrapper" [class.active]="navServices.language">
  <div class="current_lang">
    <div class="lang">
      <i class="flag-icon flag-icon-{{selectedLanguage.icon}}"></i><span
    class="lang-txt">{{selectedLanguage.code}}</span>
  </div>
</div>
<div class="more_lang" [class.active]="navServices.language">
  @for (lang of languages; track lang) {
    <button class="lang selected" data-value="{{lang.value}}" (click)="changeLanguage(lang)"
      [attr.aria-label]="'Change language to ' + lang.language + (lang.type ? ' (' + lang.type + ')' : '')">
      <i class="flag-icon flag-icon-{{lang.icon}}"></i>
      <span class="lang-txt">{{lang.language}}@if (lang.type) {
        <span>({{lang.type}})</span>
      }</span>
    </button>
  }
</div>
</div>